import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Mobile App Development",
      desc: "I have enough experience in developing standard mobile apps according to requirements of my clients. I use the most famous mobile app frameworks like Ionic and Flutter to create the apps.",
      icon: "fas fa-mobile-android-alt",
    },
    {
      name: "Web Design and Development",
      desc: "I design and develop secure, scalable, high performance and SEO friendly websites for my clients. I am able to use latest and famous tools and technologies to create the websites base on the client needs. ",
      icon: "fas fa-laptop",
    },
    {
      name: "UI / UX Design",
      desc: "UI / UX is one of the keys and vital elements for designing user friendly and attractive interfaces for mobile apps and websites. I am expert to use famous tools or software like Figma and Adobe XD. ",
      icon: "fas fa-palette",
    },
    {
      name: "Web Hosting",
      desc: "I provide shared, dedicated and cloud web hosting base on powerful Linux and Windows servers. Each hosting package provides separate cPanel with unlimited bandwidth, emails, databases and sub domains. ",
      icon: "fas fa-server",
    },
    {
      name: "Domain Registration",
      desc: "I am able to register local and internationals domains within 24 / 48 hours with reasonable price. I also provide business email services with your custom domain in Zoho, Microsoft 365 and Google Workspace email servers. ",
      icon: "fas fa-globe",
    },
    {
      name: "Desktop app Development",
      desc: "I have developed a lot of desktop apps base on different business types. Now I have lots of clients who are using my desktop apps in the market to improve their process of their business works.",
      icon: "fas fa-desktop",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            What I Do?
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
